export default __webpack_public_path__ + "static/media/perpetuum-ph-colored.5ec2c515.webp";